import type { FlexSection, UpsellPageDTO } from "../../types/upsell.types";
import { ShippingNoticeWithCountdown } from "../sections/ShippingNoticeWithCountdown";
import { HeroOneColumn } from "../sections/HeroOneColumn";
import { HeroTwoColumns } from "../sections/HeroTwoColumns";
import { Benefits } from "../sections/Benefits";
import { HowItWorks } from "../sections/HowItWorks";
import { IngredientList } from "../sections/IngredientList";
import { Drawer } from "../sections/Drawer";
import { Graph } from "../sections/Graph";
import { Reviews } from "../sections/Reviews";
import { ProductPicker } from "../sections/ProductPicker";
import { Disclaimer } from "../sections/Disclaimer";

type MultipleSectionUpsellProps = {
  data: UpsellPageDTO;
  countdownText: string;
  isCountdownExpired: boolean;
};

function RenderSection({
  data,
  section,
  countdownText,
  isCountdownExpired,
  linkDecline,
}: {
  data: UpsellPageDTO;
  section: FlexSection;
  countdownText: string;
  isCountdownExpired: boolean;
  linkDecline: string;
}) {
  switch (section.acf_fc_layout) {
    case "shipping_notice_countdown":
      return (
        <ShippingNoticeWithCountdown
          {...section.data}
          countdownText={countdownText}
          isCountdownExpired={isCountdownExpired}
        />
      );

    case "hero_1_column":
      return <HeroOneColumn {...section.data} />;

    case "hero_2_columns":
      return <HeroTwoColumns {...section.data} />;

    case "benefits_section":
      return <Benefits {...section.data} />;

    case "how_it_works_section":
      return <HowItWorks {...section.data} />;

    case "ingredients_section":
      return <IngredientList {...section.data} />;

    case "facts_accordion_section":
      return <Drawer {...section.data} />;

    case "graph_section":
      return <Graph {...section.data} />;

    case "reviews_section":
      return <Reviews {...section.data} />;

    case "offer_products_section":
      return (
        <ProductPicker
          {...section.data}
          link_decline={linkDecline}
          submitData={data}
        />
      );

    case "disclaimer":
      return <Disclaimer {...section.data} />;

    default:
      return null;
  }
}

export function MultipleSectionUpsell({
  data,
  countdownText,
  isCountdownExpired,
}: MultipleSectionUpsellProps) {
  const sections = data.multiple_products_sections;
  if (!sections || !Array.isArray(sections)) return null;

  const linkDecline = data.upsell_links.link_decline || "#";

  return (
    <main className="upsell-container">
      {sections.map((section, idx) => (
        <RenderSection
          key={idx}
          data={data}
          section={section}
          countdownText={countdownText}
          isCountdownExpired={isCountdownExpired}
          linkDecline={linkDecline}
        />
      ))}
    </main>
  );
}
